<template>
  <div>
    <b-container>
      <onboard-author-publisher ref="form" v-if="!formCompleted || retake" />
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OnboardAuthorPublisher from "@/components/forms/onboard";

export default {
  name: "Shelf",
  components: {
    OnboardAuthorPublisher
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile"
    }),
    formId() {
      return "onboard_authorpublisher";
      //this.$refs && this.$refs.form  && this.$refs.form.data ? this.$refs.form.data.formId : null;
      //console.log(`FormId ${formId}`);
    },
    formCompleted() {
      if (
        this.formId &&
        this.profile &&
        this.profile.statuses &&
        Array.isArray(this.profile.statuses)
      ) {
        const formObjects = this.profile.statuses.filter(aStatus => {
          return aStatus.type === "form" && aStatus.id === this.formId;
        });

        //console.log(`Form Objects ${JSON.stringify(formObjects)}`);

        return formObjects.length > 0;
      }
      return false;
    }
  },
  data() {
    return {
      loading: false,
      completed: false,
      retake: false
    };
  },
  methods: {
    handleRetake() {
      console.log("retake");
      this.retake = true;
    },
    getProfile() {
      this.loading = true;
      this.$store.dispatch("user/getProfile", "").then(res => {
        this.loading = false;
      });
    }
  },
  mounted() {
    this.getProfile();
  }
};
</script>

<style lang="css" scoped></style>
